<div class="overflow-auto container">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th scope="col">ID solicitud</th>
                <th scope="col">Dependencia</th>
                <th scope="col">Referente</th>
                <th scope="col">Director</th>
                <th scope="col">Programador</th>
                <th scope="col">Fecha solicitud del servicio</th>
                <th scope="col">Fecha prestación del servicio</th>
                <th scope="col">Estado</th>
                <th scope="col">Trayecto</th>
                <th scope="col">Origen</th>
                <th scope="col">Destino</th>
                <th scope="col">Hora salida</th>
                <th scope="col">Hora llegada</th>
                <th scope="col">Tipo de vehículo</th>
                <th scope="col">Conductor</th>
                <th scope="col">Tipo de servicio</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let solicitud of dataTable">
                <td>{{solicitud.id}}</td>
                <td>{{solicitud.vcDependencia}}</td>
                <td>{{solicitud.vcReferente}}</td>
                <td>{{solicitud.vcDirectorJefeDependencia}}</td>
                <td>{{solicitud.vcProgramador}}</td>
                <td>{{solicitud.dtFechaSolicitud}}</td>
                <td>{{solicitud.dtFechaPrestacionServicio}}</td>
                <td>{{solicitud.vcEstado}}</td>
                <td>{{solicitud.vcTrayecto}}</td>
                <td>{{solicitud.vcLugarSalida}}</td>
                <td>{{solicitud.vcLugarDestino}}</td>
                <td>{{solicitud.dtHoraSalida}}</td>
                <td>{{solicitud.dtHoraRecogida}}</td>
                <td>{{solicitud.bEsVehiculoInterno ? solicitud.vcVehiculo : solicitud.vehiculoSubContratado}}</td>
                <td>{{solicitud.vcConductor}}</td>
                <td>{{solicitud.vcTipoServicio}}</td>
            </tr>
        </tbody>
    </table>
</div>

<br>

<div class="d-flex flex-row ms-1 gap-3" *ngIf="dataTable.length > 0">
    <button class="btn btn-secondary col-2" (click)="onExport()">DESCARGAR</button>

    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onExport()">
        <i class="fa-solid fa-file-excel"></i>
    </button>
</div>